export class FinanceDictionary{
    static IN_OUT_TYPE_IN=1;
    static IN_OUT_TYPE_OUT=2;
    static IN_OUT_TYPE_BAD=3;

    static PURPOSE_CATE_GENERAL=0;
    static PURPOSE_CATE_SALE=1;
    static PURPOSE_CATE_BUY=2;
}
export class FinanceSource{
    static InOutTypeSource=[
        {value:FinanceDictionary.IN_OUT_TYPE_IN,text:"收入"},
        {value:FinanceDictionary.IN_OUT_TYPE_OUT,text:"支出"},
        {value:FinanceDictionary.IN_OUT_TYPE_BAD,text:"坏账"}
    ];
    static InOutCateSource=[
        {value:FinanceDictionary.PURPOSE_CATE_GENERAL,text:"普通"},
        {value:FinanceDictionary.PURPOSE_CATE_SALE,text:"销售货款"},
        {value:FinanceDictionary.PURPOSE_CATE_BUY,text:"采购"}
    ];
}